// page title must be declared in frontend/src/business/router/pages.translate.tsx
export const getPageTradKey = (pageKey: string) => `pages.${pageKey}.title`;
